interface AchRejectCode {
  code: string;
  description: string;
  action: AchRejectAction;
  isRed: boolean;
  actionRequired: string;
}

enum AchRejectAction {
  none = '',
  sufficientFunds = 'Contact merchant to have sufficient funds available in their account',
  correctAccount = 'Contact merchant to correct account/routing number',
  authorize = 'Contact merchant to authorize our ACH ID Evolve ACH ID: 1853915627',
  proceed = 'Contact merchant/agent on how they would like to proceed with the account.',
  removeStopPayment = 'Contact merchant to have them remove the stop payment',
  updatedBankingInfo = 'Contact merchant to provide updated banking information ',
  newAuthorization = 'Contact merchant to have them obtain a new authorization',
  updateInfo = 'Contact support to update information',
  accountFrozen = 'Contact merchant to clear up the account frozen',
}

export const AchRejectCodes: AchRejectCode[] = [
  {
    code: 'R01',
    description: 'INSUFFICIENT FUNDS',
    action: AchRejectAction.sufficientFunds,
    isRed: false,
    actionRequired: 'Contact merchant to have sufficient funds available in their account',
  },
  {
    code: 'R02',
    description: 'ACCOUNT CLOSED',
    action: AchRejectAction.correctAccount,
    isRed: true,
    actionRequired: 'Contact merchant to correct account/routing number',
  },
  {
    code: 'R03',
    description: 'NO ACCNT/UNABLE TO LOCATE ACCNT',
    action: AchRejectAction.correctAccount,
    isRed: true,
    actionRequired: 'Contact merchant to correct account/routing number',
  },
  {
    code: 'R04',
    description: 'INVALID ACCOUNT NUMBER',
    action: AchRejectAction.correctAccount,
    isRed: true,
    actionRequired: 'Contact merchant to correct account/routing number',
  },
  {
    code: 'R05',
    description: 'Unauthorized debit to consumer accounting using corporate SEC Code',
    action: AchRejectAction.authorize,
    isRed: false,
    actionRequired: 'Contact merchant to authorize our ACH ID Evolve ACH ID: 1853915627',
  },
  {
    code: 'R06',
    description: "RETURNED PER ODFI's REQUEST ODFI",
    action: AchRejectAction.proceed,
    isRed: false,
    actionRequired: 'Contact merchant/agent on how they would like to proceed with the account.',
  },
  {
    code: 'R07',
    description: 'AUTHORIZATION REVOKED BY CUSTOMER',
    action: AchRejectAction.proceed,
    isRed: false,
    actionRequired: 'Contact merchant/agent on how they would like to proceed with the account.',
  },
  {
    code: 'R08',
    description: 'PAYMENT STOPPED',
    action: AchRejectAction.newAuthorization,
    isRed: false,
    actionRequired: 'Contact merchant to have them remove the stop payment',
  },
  {
    code: 'R09',
    description: 'UNCOLLECTED FUNDS',
    action: AchRejectAction.updatedBankingInfo,
    isRed: false,
    actionRequired: 'Contact merchant to provide updated banking information',
  },
  {
    code: 'R10',
    description: 'CUSTOMER ADVISES NOT AUTHORIZED',
    action: AchRejectAction.newAuthorization,
    isRed: true,
    actionRequired: 'Contact merchant to have them obtain a new authorization',
  },
  {
    code: 'R11',
    description: 'CHECK SAFEKEEPING ENTRY RETURN',
    action: AchRejectAction.updatedBankingInfo,
    isRed: false,
    actionRequired: 'Contact support to update information',
  },
  {
    code: 'R12',
    description: 'BRANCH SOLD TO ANOTHER DFI',
    action: AchRejectAction.proceed,
    isRed: false,
    actionRequired: 'Contact merchant/agent on how they would like to proceed with the account.',
  },
  {
    code: 'R13',
    description: 'RDFI Not Qualified to Participate',
    action: AchRejectAction.correctAccount,
    isRed: false,
    actionRequired: 'Contact merchant to correct account/routing number',
  },
  {
    code: 'R14',
    description: 'ACCOUNT-HOLDER DECEASED',
    action: AchRejectAction.proceed,
    isRed: false,
    actionRequired: 'Contact merchant/agent on how they would like to proceed with the account.',
  },
  {
    code: 'R15',
    description: 'BENEFICIARY DECEASED',
    action: AchRejectAction.proceed,
    isRed: false,
    actionRequired: 'Contact merchant/agent on how they would like to proceed with the account.',
  },
  {
    code: 'R16',
    description: 'ACCOUNT FROZEN',
    action: AchRejectAction.accountFrozen,
    isRed: true,
    actionRequired: 'Contact merchant to clear up the account frozen',
  },
  {
    code: 'R17',
    description: 'FILE RECORD EDIT CRITERIA',
    action: AchRejectAction.updatedBankingInfo,
    isRed: false,
    actionRequired: 'Contact support to update information',
  },
  {
    code: 'R18',
    description: 'IMPROPER EFFECTIVE ENTRY DATE',
    action: AchRejectAction.updatedBankingInfo,
    isRed: false,
    actionRequired: 'Contact support to update information',
  },
  {
    code: 'R19',
    description: 'Amount Field in Error',
    action: AchRejectAction.updatedBankingInfo,
    isRed: false,
    actionRequired: 'Contact support to update information',
  },
  {
    code: 'R20',
    description: 'NON-TRANSACTION ACCOUNT',
    action: AchRejectAction.updatedBankingInfo,
    isRed: false,
    actionRequired: 'Contact merchant to provide updated banking information',
  },
  {
    code: 'R21',
    description: 'INVALID COMPANY IDENTIFICATION',
    action: AchRejectAction.updatedBankingInfo,
    isRed: false,
    actionRequired: 'Contact support to update information',
  },
  {
    code: 'R22',
    description: 'INVALID INDIVIDUAL ID NUMBER',
    action: AchRejectAction.updatedBankingInfo,
    isRed: false,
    actionRequired: 'Contact support to update information',
  },
  {
    code: 'R23',
    description: 'CREDIT REFUSED BY RECEIVER',
    action: AchRejectAction.proceed,
    isRed: false,
    actionRequired: 'Contact merchant/agent on how they would like to proceed with the account.',
  },
  {
    code: 'R24',
    description: 'DUPLICATE ENTRY',
    action: AchRejectAction.updatedBankingInfo,
    isRed: false,
    actionRequired: 'Contact support to update information',
  },
  {
    code: 'R25',
    description: 'Addenda Error',
    action: AchRejectAction.updatedBankingInfo,
    isRed: false,
    actionRequired: 'Contact support to update information',
  },
  {
    code: 'R26',
    description: 'Mandatory Field Error',
    action: AchRejectAction.updatedBankingInfo,
    isRed: false,
    actionRequired: 'Contact support to update information',
  },
  {
    code: 'R27',
    description: 'Trace number error',
    action: AchRejectAction.updatedBankingInfo,
    isRed: false,
    actionRequired: 'Contact support to update information',
  },
  {
    code: 'R28',
    description: 'Invalid Transit Routing Number',
    action: AchRejectAction.correctAccount,
    isRed: false,
    actionRequired: 'Contact merchant to correct account/routing number',
  },
  {
    code: 'R29',
    description: 'CORP CSTMR ADVISES NOT AUTH',
    action: AchRejectAction.authorize,
    isRed: true,
    actionRequired: 'Contact merchant to authorize our ACH ID Evolve ACH ID: 1853915627',
  },
  {
    code: 'R30',
    description: 'RDFI not a participant in check truncation program',
    action: AchRejectAction.proceed,
    isRed: false,
    actionRequired: 'Contact merchant/agent on how they would like to proceed with the account.',
  },
  {
    code: 'R31',
    description: 'PERMISSIBLE RETURN ENTRY(CCI And CTX Only)',
    action: AchRejectAction.proceed,
    isRed: false,
    actionRequired: 'Contact merchant/agent on how they would like to proceed with the account.',
  },
  {
    code: 'R32',
    description: 'Receiver Non-Settlement',
    action: AchRejectAction.proceed,
    isRed: false,
    actionRequired: 'Contact merchant/agent on how they would like to proceed with the account.',
  },
  {
    code: 'R33',
    description: 'RETURN OF XCK ENTRY',
    action: AchRejectAction.proceed,
    isRed: false,
    actionRequired: 'Contact merchant/agent on how they would like to proceed with the account.',
  },
  {
    code: 'R34',
    description: 'Limited Participation DFI',
    action: AchRejectAction.proceed,
    isRed: false,
    actionRequired: 'Contact merchant/agent on how they would like to proceed with the account.',
  },
  {
    code: 'R35',
    description: 'Return of improper debit entry',
    action: AchRejectAction.proceed,
    isRed: false,
    actionRequired: 'Contact merchant/agent on how they would like to proceed with the account.',
  },
  {
    code: 'R36',
    description: 'Return of improper credit entry',
    action: AchRejectAction.proceed,
    isRed: false,
    actionRequired: 'Contact merchant/agent on how they would like to proceed with the account.',
  },
  {
    code: 'R37',
    description: 'Source document presented for payment',
    action: AchRejectAction.proceed,
    isRed: false,
    actionRequired: 'Contact merchant/agent on how they would like to proceed with the account.',
  },
  {
    code: 'R38',
    description: 'Stop payment on source document',
    action: AchRejectAction.proceed,
    isRed: false,
    actionRequired: 'Contact merchant/agent on how they would like to proceed with the account.',
  },
  {
    code: 'R39',
    description: 'Improper source document or source document presented for payment',
    action: AchRejectAction.proceed,
    isRed: false,
    actionRequired: 'Contact merchant/agent on how they would like to proceed with the account.',
  },
  {
    code: 'R40',
    description: 'Return of ENR entry by Federal Government Agency',
    action: AchRejectAction.updatedBankingInfo,
    isRed: false,
    actionRequired: 'Contact support to update information',
  },
  {
    code: 'R41',
    description: 'Invalid transaction code',
    action: AchRejectAction.updatedBankingInfo,
    isRed: false,
    actionRequired: 'Contact support to update information',
  },
  {
    code: 'R42',
    description: 'Routing number or check digit error',
    action: AchRejectAction.correctAccount,
    isRed: false,
    actionRequired: 'Contact merchant to correct account/routing number',
  },
  {
    code: 'R43',
    description: 'Invalid DFI account number',
    action: AchRejectAction.updatedBankingInfo,
    isRed: false,
    actionRequired: 'Contact support to update information',
  },
  {
    code: 'R44',
    description: 'Invalid individual ID number or identification number',
    action: AchRejectAction.updatedBankingInfo,
    isRed: false,
    actionRequired: 'Contact support to update information',
  },
  {
    code: 'R45',
    description: 'Invalid individual name or company name',
    action: AchRejectAction.updatedBankingInfo,
    isRed: false,
    actionRequired: 'Contact support to update information',
  },
  {
    code: 'R46',
    description: 'Invalid representative payee indicator',
    action: AchRejectAction.updatedBankingInfo,
    isRed: false,
    actionRequired: 'Contact support to update information',
  },
  {
    code: 'R47',
    description: 'Duplicate enrollment',
    action: AchRejectAction.updatedBankingInfo,
    isRed: false,
    actionRequired: 'Contact merchant/agent on how they would like to proceed with the account.',
  },
  {
    code: 'R50',
    description: 'STATE LAW AFFECTING RCK ACCEPTANCE',
    action: AchRejectAction.updatedBankingInfo,
    isRed: false,
    actionRequired: 'Contact merchant/agent on how they would like to proceed with the account.',
  },
  {
    code: 'R51',
    description: 'ITEM IS INELIGIBLE, NOTICE NOT PROVIDED, SIGNATURE NOT GENUINE, OR ITEM ALTERED',
    action: AchRejectAction.updatedBankingInfo,
    isRed: false,
    actionRequired: 'Contact merchant/agent on how they would like to proceed with the account.',
  },
  {
    code: 'R52',
    description: 'STOP PAYMENT ON ITEM',
    action: AchRejectAction.updatedBankingInfo,
    isRed: false,
    actionRequired: 'Contact merchant/agent on how they would like to proceed with the account.',
  },
  {
    code: 'R53',
    description: 'Item and RCK entry presented for payment',
    action: AchRejectAction.updatedBankingInfo,
    isRed: false,
    actionRequired: 'Contact merchant/agent on how they would like to proceed with the account.',
  },
  {
    code: 'R61',
    description: 'MISROUTED RETURN',
    action: AchRejectAction.updatedBankingInfo,
    isRed: false,
    actionRequired: 'Contact merchant/agent on how they would like to proceed with the account.',
  },
  {
    code: 'R62',
    description: 'INCORRECT TRACE NUMBER',
    action: AchRejectAction.updatedBankingInfo,
    isRed: false,
    actionRequired: 'Contact merchant/agent on how they would like to proceed with the account.',
  },
  {
    code: 'R63',
    description: 'INCORRECT DOLLAR AMOUNT',
    action: AchRejectAction.updatedBankingInfo,
    isRed: false,
    actionRequired: 'Contact support to update information',
  },
  {
    code: 'R64',
    description: 'INCORRECT INDIVIDUAL IDENTIFICATION',
    action: AchRejectAction.updatedBankingInfo,
    isRed: false,
    actionRequired: 'Contact support to update information',
  },
  {
    code: 'R65',
    description: 'INCORRECT TRANSACTION CODE',
    action: AchRejectAction.updatedBankingInfo,
    isRed: false,
    actionRequired: 'Contact support to update information',
  },
  {
    code: 'R66',
    description: 'INCORRECT COMPANY IDENTIFICATION',
    action: AchRejectAction.updatedBankingInfo,
    isRed: false,
    actionRequired: 'Contact support to update information',
  },
  {
    code: 'R67',
    description: 'DUPLICATE RETURN',
    action: AchRejectAction.updatedBankingInfo,
    isRed: false,
    actionRequired: 'Contact merchant/agent on how they would like to proceed with the account.',
  },
  {
    code: 'R68',
    description: 'UNTIMELY RETURN',
    action: AchRejectAction.updatedBankingInfo,
    isRed: false,
    actionRequired: 'Contact merchant/agent on how they would like to proceed with the account.',
  },
  {
    code: 'R69',
    description: 'MULTIPLE ERRORS',
    action: AchRejectAction.updatedBankingInfo,
    isRed: false,
    actionRequired: 'Contact support to update information',
  },
  {
    code: 'R80',
    description: 'CROSS BORDER CODING ERROR',
    action: AchRejectAction.updatedBankingInfo,
    isRed: false,
    actionRequired: 'Contact merchant/agent on how they would like to proceed with the account.',
  },
  {
    code: 'R81',
    description: 'NON-PARTICIPANT IN CROSS-BORDER PROGRAM',
    action: AchRejectAction.updatedBankingInfo,
    isRed: false,
    actionRequired: 'Contact merchant/agent on how they would like to proceed with the account.',
  },
  {
    code: 'R82',
    description: 'INVALID FOREIGN RECEIVING DFI INDENTIFICATION',
    action: AchRejectAction.updatedBankingInfo,
    isRed: false,
    actionRequired: 'Contact merchant/agent on how they would like to proceed with the account.',
  },
  {
    code: 'R83',
    description: 'FOREIGN RECEIVING DFI UNABLE TO SETTLE',
    action: AchRejectAction.updatedBankingInfo,
    isRed: false,
    actionRequired: 'Contact merchant/agent on how they would like to proceed with the account.',
  },
  {
    code: 'R84',
    description: 'Entry Not Processed by OGO',
    action: AchRejectAction.updatedBankingInfo,
    isRed: false,
    actionRequired: 'Contact merchant/agent on how they would like to proceed with the account.',
  },
  {
    code: 'R85',
    description: 'Incorrectly coded outbound international payment',
    action: AchRejectAction.updatedBankingInfo,
    isRed: false,
    actionRequired: 'Contact merchant/agent on how they would like to proceed with the account.',
  },
  {
    code: 'R2969',
    description: 'Insufficient Funds but wait 30 days before submitting again',
    action: AchRejectAction.updatedBankingInfo,
    isRed: false,
    actionRequired: 'Contact merchant/agent on how they would like to proceed with the account.',
  },
  {
    code: 'C01',
    description: 'Incorrect bank account number',
    action: AchRejectAction.none,
    isRed: false,
    actionRequired: '',
  },
  {
    code: 'C02',
    description: 'Incorrect Transit/Routing Number',
    action: AchRejectAction.none,
    isRed: false,
    actionRequired: '',
  },
  {
    code: 'C03',
    description: 'Incorrect transit/routing number and bank account number',
    action: AchRejectAction.none,
    isRed: false,
    actionRequired: '',
  },
  {
    code: 'C04',
    description: 'Bank account name change',
    action: AchRejectAction.none,
    isRed: false,
    actionRequired: '',
  },
  {
    code: 'C05',
    description: 'Incorrect Transaction Code',
    action: AchRejectAction.none,
    isRed: false,
    actionRequired: '',
  },
  {
    code: 'C06',
    description: 'Incorrect DFI Account Number and Incorrect Transaction Code',
    action: AchRejectAction.none,
    isRed: false,
    actionRequired: '',
  },
];

export const findAchRejectCode = (code: string) => AchRejectCodes.find(rc => rc.code === code);
